/** @format */
import { Trans, useTranslation } from 'next-i18next';
import React from 'react';
import styled from 'styled-components';

import { WrappedLink } from '@toucan/client/global/nextjs';

import { getAuthorFullName } from '@toucan/client/features/contentful/helpers/author';
import { useAuthorPagePath } from '@toucan/client/features/contentful/hooks/use-author-page-path';

import { ContentfulPicture } from '../picture';
import { styles } from './author-credit.styles';
import { AuthorCreditProps } from './config/types';

const StyledAuthorCredit = styled.div`
    ${styles}
`;

export type { AuthorCreditProps } from './config/types';

export const AuthorCredit = ({
    getText,
    person,
    date,
    className,
}: AuthorCreditProps) => {
    const { t } = useTranslation();

    const pagePath = useAuthorPagePath(person);
    const name = person ? getAuthorFullName(person) : null;

    if (!name) return null;

    const personLink = pagePath ? (
        <WrappedLink href={pagePath.route} as={pagePath.path} />
    ) : (
        <span />
    );

    return (
        <StyledAuthorCredit className={className}>
            <div className="author-credit__avatar">
                <ContentfulPicture image={person?.authorImage} />
            </div>
            <div className="author-credit__info">
                <Trans components={{ 'author-link': personLink }}>
                    {getText(name)}
                </Trans>
                {date && (
                    <span className="author-credit__date">
                        {t('On {{date}}', { date })}
                    </span>
                )}
            </div>
        </StyledAuthorCredit>
    );
};
